<template>
  <div class="welcome-screen text-center safe-area">
    <h1 class="title" v-html="title"></h1>
    <img class="bottom" src="../../assets/WelcomeToScan/bottom.svg" />
  </div>
</template>

<script>
export default {
  name: 'Welcome',
  props: {
    title: String,
  },
};
</script>

<style lang="scss" scoped>
.welcome-screen {
  @apply relative flex flex-col items-center justify-center;
  height: 40%;
  padding: 40px 30px;
  background: radial-gradient(
    77.18% 77.18% at 50% 100%,
    #fcfcfc 0%,
    rgba(130, 135, 155, 0.35) 94.22%
  );
  @screen md {
    height: 45%;
  }
}
.plus-wrapper {
  position: absolute;
  top: 5%;
  width: 50px;
  height: 50px;
  overflow: visible;
  align-self: flex-start;
}
.plus {
  position: absolute;
  max-width: 54px;
  @screen md {
    max-width: 120px;
  }

  &.small {
    width: 30px;
    @screen md {
      width: 50px;
    }
  }
}
.title {
  @apply text-2xl;
  @screen md {
    font-size: 40px;
    line-height: 60px;
  }
  font-weight: 900;
  color: #262626;
  transition: opacity;
  transition-duration: 0.5s;
}
.bottom {
  position: absolute;
  top: 30%;
  right: 0;
  height: 60%;
  @screen md {
    height: initial;
    bottom: 0;
  }
}
</style>
